class BuildTags {
}
/** Hash the last time inertia was built */
BuildTags.buildHash = '8aff834d';
/** Version of the package.json file the last time inertia was built */
BuildTags.packageVersion = '1203.0.2';
/** Time inertia was built in UTC */
BuildTags.buildTime = 'Wed, 07 Oct 2026 14:28:00 GMT';
/** Time inertia was built in Boston time */
BuildTags.buildTimeBoston = '2026-10-07 10:27:51 Boston';
/** Detailed build tags string */
BuildTags.detailed = 'BuildTags: 2026-10-07 10:27:51 Boston - 8aff834d - 1203.0.2';
export default BuildTags;
